import { defineMessages } from 'react-intl';

const ID_PREFIX = 'WacSignupForm.';
export const messages = defineMessages({
  socialSignUpLoadingText: {
    id: `${ID_PREFIX}socialSignUpLoadingText`,
    defaultMessage: 'checking a few things...'
  },
  socialSignUpErrorTextContactUs: {
    id: `${ID_PREFIX}socialSignUpErrorTextContactUs`,
    defaultMessage:
      '<div>If the problem persists, <a href="{contactUsUrl}">contact us</a>.</div>'
  },
  socialSignUpSomethingWentWrong: {
    id: `${ID_PREFIX}socialSignUpSomethingWentWrong`,
    defaultMessage: '<h3>Something went wrong</h3>'
  },
  socialSignUpSorryForTheInconvenience: {
    id: `${ID_PREFIX}socialSignUpSorryForTheInconvenience`,
    defaultMessage: '<div>Sorry for the inconvenience</div>'
  }
});
